import CampusEditForm from './campus-edit-form/campus-edit-form';
import ClientEditComponent from './client-edit-component';
import ClientEditService from './client-edit-service';
import ClientEditForm from './client-edit-form/client-edit-form';
import FacilityEditForm from './facility-edit-form/facility-edit-form';
import NewCampusModal from './new-campus-modal/new-campus-modal';
import NewFacilityModal from './new-facility-modal/new-facility-modal';

/***
 * The Client Edit page. Contains a tree-navigation panel for selecting the client or any of its campuses and
 * facilities and rendering their settings editing page.
 */
const clientEdit = angular
    .module('FacilityData.ClientEdit', [
        CampusEditForm,
        ClientEditForm,
        FacilityEditForm,
        NewCampusModal,
        NewFacilityModal
    ])
    .component('clientEdit', ClientEditComponent)
    .service('ClientEditService', ClientEditService)
    .config(($stateProvider) => {
        'ngInject';

        $stateProvider.state('app.client-edit', {
            url:'/client-admin/:clientId/edit/',
            component: 'clientEdit',
            resolve: {
                userAuth: (
                    $state,
                    updateUser,
                    CurrentUser
                ) => {
                    if (!CurrentUser.isClientAdmin()) {
                        $state.go('app.home', {}, {reload: true});
                    }
                },
                relatedModels: (FacilitySettings) => FacilitySettings.getRelatedModels(),
                 client: (
                    $stateParams,
                    CommonRequest
                ) => CommonRequest.getClient($stateParams.clientId),
                clientTree: (
                    $stateParams,
                    ClientEditService
                ) => {
                    return ClientEditService.getClientTreeView($stateParams.clientId);
                },

            }
        });

    })
    .name;

export default clientEdit;


// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit.js